// 📱 MobileHeader - En-tête mobile minimaliste
// Affiche uniquement le lecteur radio et le toggle dark mode en haut à droite
// Utilisé dans : src/components/layout/Navigation.jsx

import { useState } from 'react'
import { Sun, Moon } from 'lucide-react'
import globalData from '@/locales/global.json'
import { MiniRadioPlayer, MobileRadioPanel } from '@/components/RadioPlayer'

/**
 * En-tête mobile léger fixé en haut à droite
 * Contient le lecteur radio flottant et le bouton de changement de thème
 * Visible uniquement sur écrans < lg (1024px)
 * 
 * @param {Object} props - Propriétés du composant
 * @param {boolean} props.darkMode - État du thème sombre
 * @param {Function} props.toggleDarkMode - Fonction pour basculer le thème
 */
export default function MobileHeader({ darkMode, toggleDarkMode }) {
  const { labels } = globalData
  const [showControls, setShowControls] = useState(false)

  return (
    <>
      <header className="md:hidden fixed top-0 right-0 z-50 p-4 flex items-center gap-2">
        {/* Radio Rock Mini Player */}
        <MiniRadioPlayer 
          showControls={showControls}
          onControlsToggle={() => setShowControls(!showControls)}
          isDesktop={false}
        />

        {/* Bouton Dark Mode Toggle */}
        <button 
          onClick={toggleDarkMode}
          className="p-2.5 rounded-full bg-white/90 dark:bg-neutral-700/90 text-neutral-700 dark:text-neutral-100 backdrop-blur-md hover:bg-white dark:hover:bg-neutral-600 transition-all shadow-lg"
          aria-label={labels.darkMode}
        >
          {darkMode ? <Sun className="text-amber-400" size={20} /> : <Moon size={20} />}
        </button>
      </header>

      {/* Panneau de contrôle mobile */}
      <MobileRadioPanel 
        showControls={showControls}
        onClose={() => setShowControls(false)}
      />
    </>
  )
}
